import React from 'react';
import { OneformFeatureAppDependencies } from '.';

export const FeatureServicesContext = React.createContext<OneformFeatureAppDependencies | undefined>(undefined);

export function useFeatureServices(): OneformFeatureAppDependencies {
	const featureServices = React.useContext(FeatureServicesContext);

	if (!featureServices) {
		throw new Error('No featureServices context value was provided.');
	}

	return featureServices;
}
